import { render, staticRenderFns } from "./avg.vue?vue&type=template&id=7a901c4c&scoped=true&"
import script from "./avg.vue?vue&type=script&lang=js&"
export * from "./avg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a901c4c",
  null
  
)

export default component.exports